import { DashboardLayout } from '../../client/components/Sidebar';
import DefaultReceptionPage from './DefaultReceptionPage';
import LoadingSpinner from '../../admin/layout/LoadingSpinner';
import { pageLayoutStyles } from '../../components/ui/page-layout';

export default function ReceptionPage() {
  return <DefaultReceptionPage />;
}
